import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import 'rxjs/add/operator/map';


@Injectable()
export class FunderDashboardService {

  constructor(
    public http: HttpClient
  ) {
  }

  getFunderByUser(userId) {
    const url = `${environment.URL_SERVICIOS}/reports/get_funder_by_user/${userId}`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getFunderCreditLines(funderId) {
    const url = `${environment.URL_SERVICIOS}/reports/funder_credit_lines/${funderId}`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

  getFunderInvoices(funderId) {
    const url = `${environment.URL_SERVICIOS}/reports/funder_invoices/${funderId}`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return resp;
      } )
    );
  }

}
